/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import {EditIconRenderer,  ReadOnlyCheckBoxRenderer} from "../../shared/ag-grid-helper/GridRenderers";
import agGridHelper from "../../shared/ag-grid-helper";
import SideBarEditForm from "../../shared/forms/SideBarEditForm";
import Form from "../../shared/forms/Form";
import Field from "../../shared/forms/Field";
import FormTextBox from "../../shared/forms/FormFields/FormTextBox";
import useApiProveedoresDiesel from "../../api/catalogos/useApiProveedoresDiesel";
import constantes from '../constantes';
import useSeguridad from "../../Seguridad/useSeguridad";

const Proveedores = () => {
const seguridad = useSeguridad();
const soloLectura = !seguridad.esEditable(constantes.menus.proveedoresDiesel);
    const api = useApiProveedoresDiesel();

    const [datos, setDatos] = useState([]);
    const [currentId, setCurrentId] = useState(null);

    useEffect(() => {
        load().then();
    }, []);

    const load = async () => {
        const datos = await api.filtrar();
        setDatos(datos);
    }

    return (
        <>
            <div className="ag-theme-balham grid-principal">
                <AgGridReact
                    rowSelection={'single'}
                    enableSorting={true}
                    frameworkComponents={{
                        readOnlyCheckBoxRenderer: ReadOnlyCheckBoxRenderer,
                        editRenderer: EditIconRenderer
                    }}
                    defaultColDef={agGridHelper.defaultColumns}
                    rowData={datos}
                    context={{
                        onEdit: (id) => setCurrentId(id)
                    }}
                >
                    <AgGridColumn field="nombre" headerName="Nombre" cellClass={'left'}/>
                    <AgGridColumn field="color" headerName="Color" cellClass={'left'}/>
                    <AgGridColumn field="enabled" headerName="Activa" cellRenderer={'readOnlyCheckBoxRenderer'}/>
                    <AgGridColumn maxWidth={60} cellClass={'center'}
                                  cellRenderer="editRenderer"/>
                </AgGridReact>
            </div>

            <SideBarEditForm id={currentId}
                             initialValues={{enabled: true}}
                             getByIdFunction={api.obtener}
                             saveFunction={api.guardar}
                             deleteFunction={api.eliminar}
                             formDisabled={soloLectura}
                             onSaved={() => {
                                 load().then();
                                 setCurrentId(null);

                             }}
                             onCancel={() => setCurrentId(null)}
            >
                <Form columns={1}>
                    <h5>Proveedor</h5>
                    <Field field={"nombre"} label={"Nombre"} required={true} render={FormTextBox}/>
                    <Field field={"color"} label={"Color"} render={FormTextBox}/>
                </Form>
            </SideBarEditForm>
        </>
    )
}

export default Proveedores;
